/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function CollectionAddToCart() {
  $('.CollectionAddToCart').on('click', function(e) {
    e.preventDefault();
    var this_form = $(this).parents('form:first');
    var this_variant = this_form.data('variant-id');
    var jqxhr = $.post('/cart/add.js', $(this_form).serialize());
    
    jqxhr.always(function() { 
      document.dispatchEvent(new CustomEvent('product:added',
      {
      bubbles: true,
      detail: {
        variant: { 'id': this_variant },
        quantity: parseInt(1)
      }
    }))
    })
  });
}

function ResizeCarouselCell() {
  let cells = document.querySelectorAll('.ProductList .Carousel__Cell');

  cells.forEach(function(cell) {
    cell.style.height = "100%";
  });

}

function UpsellAddToCart(e){
  
  var vid = $(e).data('vid');
  
    var jqxhr = $.post('/cart/add.js', "id="+vid+"&quantity=1");
    jqxhr.always(function() {
      document.dispatchEvent(new CustomEvent('product:added',
      {
        bubbles: true,
        detail: {
          variant: { 'id': vid },
          quantity: parseInt(1)
        }
      }))
    });
    
  return false;
}


$(window).load(function() {
  CollectionAddToCart();
  ResizeCarouselCell();
});


// Replace Links
ReplaceLink = function(e) {
  e.preventDefault();
  window.location.href = $(this).attr('data-url');
  console.log($(this).attr('data-url'));
}

var replace_links = document.getElementsByClassName('replace-link');
for (var i=0; i < replace_links.length; i++) {
  replace_links.item(i).onclick = ReplaceLink;
} 


 document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
   $('.metalink').hide(); 
   $('.ctm-wraaaper').show();
   $('#variant-meta-'+variant.id).show(); 
   $('#variant-meta-'+variant.id).parent().find('.ctm-wraaaper').hide();
  });